import { Component, OnInit, Input } from '@angular/core';
import { DTOResetPassword } from '../../../@core/models/dto-reset-password';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-reset-password-token',
  templateUrl: './reset-password-token.component.html',
  styleUrls: ['./reset-password-token.component.scss'],
})
export class ResetPasswordTokenComponent implements OnInit {

  @Input() email: string;
  public token: string;
  public newPassword: string;

  constructor(
    private router: Router) { }

  ngOnInit() {
  }

  public resetPassword() {
    const dtoResetPassword = new DTOResetPassword();
    dtoResetPassword.ResetPasswordToken = this.token;
    dtoResetPassword.NewPassword = this.newPassword;
    dtoResetPassword.Email = this.email;
  }
}
